import { render, staticRenderFns } from "./ResolutionDetail.vue?vue&type=template&id=f2d59872&"
import script from "./ResolutionDetail.vue?vue&type=script&lang=js&"
export * from "./ResolutionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports